import React from "react";

export default function NewsItem({ section }) {
  const { title, date, author, article, subTitle, mainImage = {} } = section?.content || {};

  return (
    <>
      <section className="wrapper bg-soft-primary">
        <div className="container pt-10 pb-19 pt-md-14 pb-md-20 text-center">
          <div className="row">
            <div className="col-md-10 col-xl-8 mx-auto">
              <div className="post-header">
                <h1 className="display-1 mb-4">{title}</h1>
                <div className="post-meta mb-5">
                  <div className="post-date me-2">
                    <i className="uil uil-calendar-alt"></i>
                    <span>{date}</span>
                  </div>
                  <div className="post-author">
                    <div className="u-link">
                      <i className="uil uil-user"></i>
                      <span>{author}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wrapper bg-light">
        <div className="container pb-14 pb-md-16">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="blog single mt-n17">
                <div className="card">
                  <figure className="card-img-top">
                    <img src={mainImage.url} alt="" />
                  </figure>
                  <div className="card-body">
                    <div className="classic-view">
                      <article className="post">
                        <div className="post-content mb-5">
                          <h2 className="h1 mb-4">{subTitle}</h2>
                          <p>{article}</p>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
